const rpcUrl = 'https://magical-alien-snow.injective-mainnet.quiknode.pro/d0795ac4b9205bc47cd7e93a85a2ee9b24f60f51/',
    blockExplorers = 'https://blockscout.injective.network'
export default {
    id: 1776,
    name: 'Injective',
    network: 'injective',
    nativeCurrency: {name: 'Injective', symbol: 'INJ', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'Injective explorer', url: blockExplorers},
        default: {name: 'Injective explorer', url: blockExplorers},
    },
    contracts: {},
}